function disableDocumentScrolling() {
  if (document.documentElement.style.position !== 'fixed') {
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;
    const cbCompensateObjects = document.querySelectorAll('.sb-compensate');
    let topVerticalOffset = 0;
    if (typeof window.scrollY !== 'undefined') {
      topVerticalOffset = window.scrollY;
    } else if (document.documentElement.scrollTop) {
      topVerticalOffset = document.documentElement.scrollTop;
    }
    document.documentElement.classList.add('scroll-disabled');
    document.documentElement.style.position = 'fixed';
    document.documentElement.style.marginTop = `-${topVerticalOffset}px`;
    document.documentElement.style.paddingRight = `${scrollBarWidth}px`;
    for (let i = 0; i < cbCompensateObjects.length; i += 1) {
      cbCompensateObjects[i].style.paddingRight = `${scrollBarWidth}px`;
    }
  }
}

function enableDocumentScrolling() {
  if (document.documentElement.style.position === 'fixed') {
    const cbCompensateObjects = document.querySelectorAll('.sb-compensate');
    document.documentElement.style.position = null;
    const scrollPosition = -1 * parseFloat(document.documentElement.style.marginTop);
    document.documentElement.classList.remove('scroll-disabled');
    document.documentElement.style.marginTop = null;
    document.documentElement.style.paddingRight = null;
    for (let i = 0; i < cbCompensateObjects.length; i += 1) {
      cbCompensateObjects[i].style.paddingRight = null;
    }
    window.scrollTo(0, scrollPosition);
  }
}

const easeInOutQuad = (time, begin, change, duration) => {
  let newTime = time;
  newTime /= duration / 2;
  if (newTime < 1) return (change / 2) * newTime * newTime + begin;
  newTime -= 1;
  return (-change / 2) * (newTime * (newTime - 2) - 1) + begin;
};

function scrollPageTo(to, duration = 500) {
  const start = document.documentElement.scrollTop;
  const change = to - start;
  let currentTime = 0;
  const increment = 20;

  const animateScroll = () => {
    currentTime += increment;
    document.documentElement.scrollTop = easeInOutQuad(currentTime, start, change, duration);
    if (currentTime < duration) {
      setTimeout(animateScroll, increment);
    }
  };
  animateScroll();
}

function expandMaxHeight(element, container, activeClassName = 'active') {
  element.style.width = getComputedStyle(element).width;
  element.style.position = 'absolute';
  element.style.visibility = 'hidden';
  element.style.maxHeight = 'none';

  const { height } = getComputedStyle(element);
  element.style.width = null;
  element.style.position = null;
  element.style.visibility = null;
  element.style.maxHeight = 0;

  setTimeout(() => {
    element.style.maxHeight = height;
  });

  container.classList.add(activeClassName);

  element.addEventListener(
    'transitionend',
    () => {
      element.style.maxHeight = null;
    },
    { once: true },
  );
}

function collapseMaxHeight(element, container, activeClassName = 'active') {
  element.style.maxHeight = getComputedStyle(element).height;

  setTimeout(() => {
    element.style.maxHeight = 0;
  });

  container.classList.remove(activeClassName);

  element.addEventListener(
    'transitionend',
    () => {
      element.style.maxHeight = null;
    },
    { once: true },
  );
}

export { disableDocumentScrolling, enableDocumentScrolling, scrollPageTo, expandMaxHeight, collapseMaxHeight };
